<script lang="ts">
	import PhoneFrame from './PhoneFrame.svelte'
	import ListingScreen from './ListingScreen.svelte'
	import Button from '../buttons/Button.svelte'
	import { track } from '$lib/utils/track'
	import { goto } from '$app/navigation'

	const logos = [
		['Washington Post', '/visuals/press-logos/wp.webp'],
		['Forbes', '/visuals/press-logos/forbes.webp'],
		['Business Traveler', '/visuals/press-logos/bt.webp'],
		['Skift', '/visuals/press-logos/skift.webp'],
	]

	function applyForGuide() {
		track('Apply to Guide Clicked')
		goto('/store')
		// window.open('https://abqi8g6kjwn.typeform.com/to/CY91sRBV', '_blank')
	}
</script>

<!-- Hero Component -->
<div class="overflow-hidden py-20 sm:py-24 lg:pb-32 xl:pb-36" data-testid="Hero">
	<div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
		<div class="lg:grid lg:grid-cols-12 lg:gap-x-8 lg:gap-y-20">
			<div class="relative z-10 max-w-2xl lg:col-span-7 lg:max-w-none lg:pt-6 xl:col-span-6">
				<h1 class="text-4xl md:text-6xl font-extrabold tracking-tight text-gray-900">
					Sell Your Premium
					<br />
					<span class="text-black">Travel Guides</span>
				</h1>
				<p class="mt-6 text-lg max-w-md text-brand-gray-5">
					Earn more from your trips by selling your best kept secrets as digital guides
				</p>
				<div class="mt-8 flex flex-col w-full sm:max-w-xs gap-y-4">
					<Button theme="dark" size="md" class="w-full" onclick={applyForGuide}>
						Set Up Your Store
					</Button>

					<div class="text-xs text-brand-gray-4 mt-3">
						Instant signup. No credit card required.
						<a href="/legal/terms" class="underline">Terms of Service</a> and
						<a href="/legal/privacy" class="underline">Privacy Policy</a>.
					</div>
				</div>
			</div>
			<div class="relative mt-10 sm:mt-20 lg:col-span-5 lg:row-span-2 lg:mt-0 xl:col-span-6">
				<div
					class="-mx-4 h-[448px] px-4 sm:px-9 [mask-image:linear-gradient(to_bottom,white_60%,transparent)] sm:mx-0 lg:absolute lg:-inset-x-10 lg:-bottom-20 lg:-top-10 lg:h-auto lg:px-0 lg:pt-10 xl:-bottom-32"
				>
					<PhoneFrame>
						<ListingScreen />
					</PhoneFrame>
				</div>
			</div>
			<div class="relative -mt-4 lg:col-span-7 lg:mt-0 xl:col-span-6">
				<p class="text-center text-sm font-semibold text-gray-900 lg:text-left">As Seen On</p>
				<ul
					role="list"
					class="mx-auto mt-8 flex max-w-xl flex-wrap justify-center gap-x-4 gap-y-8 lg:mx-0 lg:justify-start"
				>
					{#each logos as [name, logo]}
						<li class="flex">
							<img src={logo} alt={name} class="h-7" />
						</li>
					{/each}
				</ul>
			</div>
		</div>
	</div>
</div>
